module.exports = __webpack_public_path__ + "img/box-img.7e7ddf28.png";